import { render, staticRenderFns } from "./GuildMembersDialog.vue?vue&type=template&id=54e17852&scoped=true"
import script from "./GuildMembersDialog.vue?vue&type=script&lang=js"
export * from "./GuildMembersDialog.vue?vue&type=script&lang=js"
import style0 from "./GuildMembersDialog.vue?vue&type=style&index=0&id=54e17852&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e17852",
  null
  
)

export default component.exports